var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTrash = function SvgTrash(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 3.75h4v-1.5H8zM17 6.25H3v-1.5h14z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.124 7.75h11.752l-1.484 9.5H5.608zm1.752 1.5 1.016 6.5h6.216l1.016-6.5z",
    clipRule: "evenodd"
  })));
};
export { SvgTrash as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMjAgMjAiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGQ9Ik04IDMuNzVMMTIgMy43NVYyLjI1SDhWMy43NVoiLz4KPHBhdGggZD0iTTE3IDYuMjVIM1Y0Ljc1SDE3VjYuMjVaIi8+CjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNNC4xMjM3MSA3Ljc1SDE1Ljg3NjNMMTQuMzkxOSAxNy4yNUg1LjYwODA5TDQuMTIzNzEgNy43NVpNNS44NzYyOSA5LjI1TDYuODkxOTEgMTUuNzVIMTMuMTA4MUwxNC4xMjM3IDkuMjVINS44NzYyOVoiLz4KPC9zdmc+Cg==";